// import { useAuth } from "hooks/useAuth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { excluirCaixa, verCaixas } from "services/api";
import { Caixa } from "types/types";
import 'styles/homeCaixas.css'
import { paths } from "app/paths";
import { BtnVoltarHome } from "app/componentes/BtnVoltarHome";

function toNum(v: string | number) {
    const n = typeof v === "string" ? parseFloat(v) : v;
    return Number.isFinite(n) ? n : 0;
}

export const HomeCaixa = () => {

    const navigate = useNavigate();

    const [caixas, setCaixas] = useState<Caixa[]>([]);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState<string | null>(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const res = await verCaixas(); // GET /verCaixas
                const data = res.data as Caixa[] | { erro: string };

                if (Array.isArray(data)) {
                    if (!alive) return;
                    setCaixas(data);
                } else {
                    setErro(data.erro || "Falha ao carregar caixas.");
                }
            } catch (e: any) {
                const msg = e?.response?.data?.erro || e?.message || "Erro ao carregar caixas.";
                setErro(msg);
            } finally {
                setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, []);

    const handleDelete = async (id: number) => {
        setLoading(true);
        try {
            const resp = await excluirCaixa(id);
            if (resp.data) {
                setCaixas(caixas.filter(c => c.id !== id));
            }
        } catch (e: any) {
            const msg = e?.response?.data?.erro || e?.message || "Erro ao excluir caixa.";
            setErro(msg);
        }finally{
            setLoading(false);
        }
    }

    const handleEdit = (id: number) => {
        navigate(paths.editarCaixa.replace(':id', String(id)));
    }

    const handleCadastrar = () => {
        navigate(paths.cadastrarCaixa)
    }

    return (
        <div className="caixa-pagina" id="page-home-caixa">
            <div className="caixa-cartao" id="card-home-caixa">
                <header className="caixa-topo">
                    <h1 className="caixa-titulo">Minhas Caixas</h1>

                    {/* botão sempre visível */}
                    <div className="caixa-acoes-topo">
                        <button
                            id="btn-cadastrar-caixa"
                            className="botao botao--primario"
                            onClick={handleCadastrar}
                        >
                            Cadastrar Caixa
                        </button>
                    </div>
                </header>

                {/* estados */}
                {loading && <p className="caixa-info">Carregando...</p>}
                {erro && <p className="caixa-erro">{erro}</p>}
                {!loading && !erro && !caixas.length && (
                    <p className="caixa-info">Nenhuma caixa cadastrada ainda.</p>
                )}

                {!loading && !erro && !!caixas.length && (
                    <div className="caixa-tabela-wrapper">
                        <table className="caixa-tabela">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Altura (cm)</th>
                                    <th>Largura (cm)</th>
                                    <th>Comprimento (cm)</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {caixas.map((c) => (
                                    <tr key={c.id}>
                                        <td>{c.cod_identificacao}</td>
                                        <td>{c.descricao}</td>
                                        <td>{toNum(c.altura).toFixed(2)}</td>
                                        <td>{toNum(c.largura).toFixed(2)}</td>
                                        <td>{toNum(c.comprimento).toFixed(2)}</td>
                                        <td className="caixa-acoes">
                                            <button
                                                className="botao botao--danger"
                                                onClick={() => handleDelete(c.id)}
                                            >
                                                {loading ? "Excluindo..." : "Excluir"}
                                            </button>
                                            <button
                                                className="botao botao--fantasma"
                                                onClick={() => handleEdit(c.id)}
                                            >
                                                Editar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <BtnVoltarHome />
        </div>
    );
}